import { createBrowserRouter, redirect, useNavigate } from "react-router-dom";
import { AuthLayout, MainLayout } from "../Layout";

// import { store } from "../Store/store";
import { store } from "../Store/store";
import {
  AboutUs,
  BlogDetails,
  Blogs,
  Cart,
  CartConfirm,
  CartList,
  CheckPayment,
  ContactUs,
  Guide,
  Home,
  NotFound,
  ProductDetails,
  Products,
  Profile,
  ProfileFavorites,
  ProfileLayout,
  ProfileOrder,
  Rules,
} from "../Pages/Main";
import { OTP, Register, VerifyOTP } from "../Pages/Auth";

export const tokenProtector = () => {
  const token = store.getState().userSlice.token;

  // const navigate=useNavigate()
  if (!token) {
    return redirect("/auth");
    // navigate("/")
  }

  return null;
};

export const authLoader = () => {
  const token = store.getState().userSlice.token;

  // const navigate=useNavigate()
  if (token) {
    return redirect("/");
    // navigate("/")
  }

  return null;
};
const router = createBrowserRouter([
  {
    path: "",
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      // {
      //   path: "contact-us",
      //   element: <ContactUs />,
      // },
      {
        path: "contact-us",
        element: <AboutUs />,
      },
     // blogs
      {
        path: "blogs",
        children: [
          {
            index: true,
            element: <Blogs />,
          },
          {
            path: ":seoSlog",
            element: <Blogs />,
          },
        ],
      },
      {
        path: "guide",
        element: <Guide />,
      },
      {
        path: "rules",
        element: <Rules />,
      },
       // products
      {
        path: "products",
        children: [
          {
            index: true,
            element: <Products />,
          },
          {
            path: ":slug",
            element: <Products />,
          },
          {
            path: ":slug/:seoSlog",
            element: <Products />,
          },
        ],
      },
      // product details
      {
        path: "product-details",
        children: [
          {
            path: ":productCode",
            element: <ProductDetails />,
          },
          {
            path: ":productCode/:variantId",
            element: <ProductDetails />,
          },
          {
            path: ":productCode/:variantId/:seoSlug",
            element: <ProductDetails />,
          },
        ],
      },
       // blog details
      {
        path: "blog-details",
        children: [
          {
            path: ":id",
            element: <BlogDetails />,
          },
          {
            path: ":id/:seoSlog",
            element: <BlogDetails />,
          },
        ],
      },
      {
        path: "profile",
        element: <ProfileLayout />,
        loader: tokenProtector,
        children: [
          {
            index: true,
            element: <Profile />,
          },
          {
            path: "orders",
            element: <ProfileOrder />,
          },
          {
            path: "favorites",
            element: <ProfileFavorites />,
          },
        ],
      },

      {
        path: "cart",
        element: <Cart />,
        children: [
          {
            index: true,
            element: <CartList />,
          },
          {
            path: "confirm",
            element: <CartConfirm />,
          },
        ],
      },
      {
        path: "/check-payment",
        element: <CheckPayment />,
      },
    ],
  },
  {
    path: "/auth",
    element: <AuthLayout />,
    loader: authLoader,
    children: [
      {
        index: true,
        element: <OTP />,
      },
      {
        path: "verify",
        element: <VerifyOTP />,
      },
      {
        path: "register",
        element: <Register />,
      },
    ],
  },

  {
    path: "*",
    element: <NotFound />,
  },
]);
export default router;
